import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { Ng4GeoautocompleteModule } from 'ng4-geoautocomplete';
import { ColorPickerModule } from 'ngx-color-picker';
import { CKEditorModule } from 'ng2-ckeditor';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

//setting interceptors for request 
//where auth header will be added 
//and base url will append to req path 
//and further common logic
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonHttpInterceptor } from './shared/services/http-interceptor/http.interceptor';
const httpInterceptor = { provide: HTTP_INTERCEPTORS, useClass: CommonHttpInterceptor, multi: true };

//material modules
import {
  MatInputModule, MatButtonModule, MatCardModule,
  MatTabsModule, MatMenuModule, MatDialogModule,
  MatSlideToggleModule, MatSelectModule, MatCheckboxModule, MatRadioModule, MatIconModule,
  MatDatepickerModule, MatExpansionModule, MatChipsModule, MatAutocompleteModule, MatProgressSpinnerModule, MatTooltipModule, MatChipInputEvent, MatPaginatorModule, MatTableModule, MatSortModule, MatStepperModule
} from '@angular/material';


import { MatMomentDateModule } from '@angular/material-moment-adapter';
const MaterialModules = [MatInputModule, MatButtonModule, MatCardModule,
  MatTabsModule, MatMenuModule, MatDialogModule,
  MatSlideToggleModule, MatSelectModule, MatCheckboxModule, MatRadioModule, MatIconModule,
  MatDatepickerModule, MatMomentDateModule, MatExpansionModule,
  MatChipsModule, MatSnackBarModule, MatAutocompleteModule, MatProgressSpinnerModule, MatTooltipModule, MatPaginatorModule, MatTableModule, MatSortModule, MatStepperModule];

//flex layout 
import { FlexLayoutModule } from "@angular/flex-layout";

//map library
import { AgmCoreModule } from '@agm/core/';


//routing module
import { RouterModule, Routes } from '@angular/router';

//multilingual support library
import { translateModule } from './shared/services/translate/translate';

//dnd module for sortable
import { DndModule } from 'ng2-dnd';

//resize module
import { ResizableModule } from 'angular2-resizable';

//guards
import { AuthGuard, NoAuthGuard } from './shared/guards/index';
const guards = [AuthGuard, NoAuthGuard];


//services
import { UserService, PageService, DeviceService, ZoneService, BrandService, CommonService, SiteService, FutureOperationalHoursService, RoleService, CustomerService, PackageService, EventService, DashboardService, GroupService, WidgetService, PlaylistService, FaqService, AclService, SchedulerService } from './shared/services/index';
const services = [UserService, PageService, DeviceService, ZoneService, BrandService, CommonService, SiteService, FutureOperationalHoursService, RoleService, CustomerService, PackageService, EventService, DashboardService, GroupService, WidgetService, PlaylistService, FaqService, AclService, SchedulerService];

//directives
import { InputFileComponent } from './shared/directives/input-file/input-file.component';
import { ExpandToggleComponent } from './shared/directives/expand-toggle/expand-toggle.component';
import { AclDirective } from './shared/directives/acl/acl.directive';
import { ScriptHackComponent } from './shared/directives/script-hack/script-hack.component';
//template directive
const directives = [ExpandToggleComponent, InputFileComponent, AclDirective, ScriptHackComponent];


//graphs
import { GraphModule } from './shared/components/graphs/index';

//openTok
import { OpenTokModule } from './shared/components/open-tok/index';

//components
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';


import { LayoutComponent } from './shared/components/layout/layout.component';
import { GroupFilterComponent } from './shared/directives/group-filter/group-filter.component';
import { ExportMailComponent } from "./shared/export/export-mail/export-mail.component";
import { ExportSchedulerMailComponent } from "./shared/export/export-mail-scheduler/export-mail-scheduler.component";

import { DashboardComponent } from './dashboard/dashboard.component';
import { PrivateDashboardComponent } from './private-dashboard/private-dashboard.component';
import { PublicDashboardComponent } from './public-dashboard/public-dashboard.component';
import { SubscribePackageComponent } from './subscribe-package/subscribe-package.component';
import { SupportComponent } from './support/support.component';
import { EventsComponent } from './events/events.component';
import { FaqComponent } from './faq/faq.component';
import { PlayListComponent } from './play-list/play-list.component';
import { ContactSupportComponent } from './support/contact-support/contact-support.component';
import { SchedulerComponent, SchedulerDialog } from './scheduler/scheduler.component';
import { ReportsComponent } from './reports/reports.component';
//profile components
import { ProfileComponent } from './profile/profile.component';
import { PersonalComponent } from './profile/personal/personal.component';
import { UsersComponent } from './profile/users/users.component';
import { SitesComponent } from './profile/sites/sites.component';
import { FutureOperationalHoursComponent } from './profile/future-operational-hours/future-operational-hours.component';
import { DevicesComponent } from './profile/devices/devices.component';
import { ZonesComponent } from './profile/zones/zones.component';
import { SubscriptionsComponent } from './profile/subscriptions/subscriptions.component';
import { BrandsComponent } from './profile/brands/brands.component';
import { RolesComponent } from './profile/roles/roles.component';
import { GeoSitesComponent } from './profile/geosites/geosites.component';
import { SettingComponent } from './profile/setting/setting.component';
import { SandBoxDashboardComponent } from './sandbox-dashboard/sandbox-dashboard.component';
import { SandBoxInterceptorComponent } from './sandbox-interceptor/sandbox-interceptor.component';


const profile = [ProfileComponent, PersonalComponent, UsersComponent,
  SitesComponent,FutureOperationalHoursComponent, DevicesComponent, ZonesComponent, SubscriptionsComponent, GeoSitesComponent, SettingComponent];
const components = [AppComponent, LoginComponent, LayoutComponent,
  DashboardComponent, PrivateDashboardComponent, SandBoxDashboardComponent, SandBoxInterceptorComponent,
  ...profile, PublicDashboardComponent, SubscribePackageComponent,
  SupportComponent, EventsComponent, FaqComponent,
  BrandsComponent, PlayListComponent, ContactSupportComponent, GroupFilterComponent, ResetPasswordComponent, ExportMailComponent, ExportSchedulerMailComponent, SchedulerComponent, ReportsComponent];

//pipe  
import { UtcDatePipe } from './shared/pipe/utc-date.pipe';
import { EscapeHtmlPipe } from './shared/pipe/keep-html.pipe';
const pipes = [UtcDatePipe, EscapeHtmlPipe];

//dialogs
import { AddDashboardDialog } from './dashboard/dashboard.component';
import { GroupDialog } from './private-dashboard/group/group.dialog';
import { ChartDialog } from './private-dashboard/chart/chart.dialog';
import { EditDashboardDialog } from './private-dashboard/editDashboard/edit-dashboard.dialog';
import { EditPersonalDialog, ChangePasswordDialog } from './profile/personal/personal.component';
import { UserDialog } from './profile/users/users.component';
import { SiteDialog } from './profile/sites/sites.component';
import { FutureOperationalHoursDialog } from './profile/future-operational-hours/future-operational-hours.component';
import { DeviceDialog } from './profile/devices/devices.component';
import { ZoneDialog, ZoneMapDialog } from './profile/zones/zones.component';
import { IssueDialog } from './support/support.component';
import { EventDialog } from './events/events.component';
import { BrandDialog, BrandMapDialog } from './profile/brands/brands.component';
import { RoleDialog } from './profile/roles/roles.component';
import { GeoSitesDialog } from './profile/geosites/geosites.component';
import { PlayListDialog } from './play-list/play-list.component';
import { DeviceErrorDialog } from './profile/devices/devices.component';
import { DeviceFetchDataDialog } from './profile/devices/devices.component';
import { ForgotPasswordDialog } from './login/login.component';
import { ExportDashboardViewerDialog } from "./shared/export/dashboardexport/dashboard-export-dialog.component";
import { ExportGroupViewerDialog } from "./shared/export/groupexport/group-export-dialog.component";
import { ScheduleDashboardViewerDialog } from "./shared/export/dashboardschedule/dashboard-schedule-dialog.component";
import { PdfViewerDialog } from "./shared/export/pdfviewer/pdf-export-dialog.component";
import { EditSettingDialog } from './profile/setting/setting.component';
import { DateFormatDialog } from "./shared/export/export-mail/export-mail.component";
import { GeoFilterDialog } from './shared/components/graphs/geo-map/geo-map.component';
import { layoutChartDialogComponent } from './private-dashboard/layout-chart-dialog/layout-chart-dialog';

const dialogs = [AddDashboardDialog, ChartDialog, GroupDialog, PdfViewerDialog,
  EditPersonalDialog, UserDialog, SiteDialog, FutureOperationalHoursDialog,
  DeviceDialog, ZoneDialog, IssueDialog,
  EventDialog, ChangePasswordDialog, BrandDialog,
  RoleDialog, GeoSitesDialog, GeoFilterDialog, PlayListDialog, ZoneMapDialog, BrandMapDialog,layoutChartDialogComponent,
  EditDashboardDialog, DeviceErrorDialog, DeviceFetchDataDialog, ForgotPasswordDialog, ExportDashboardViewerDialog, ExportGroupViewerDialog, ScheduleDashboardViewerDialog, EditSettingDialog, DateFormatDialog, SchedulerDialog];

//ng date time picker
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';



//routes in app
const appRoutes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [NoAuthGuard] },
  { path: 'reset-password/:token', component: ResetPasswordComponent, canActivate: [NoAuthGuard] },
  {
    path: '', component: LayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'private-dashboard/:name/:id', component: PrivateDashboardComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'support', component: SupportComponent },
      { path: 'events', component: EventsComponent },
      { path: 'play-list', component: PlayListComponent },
      { path: 'contact-support/:userId', component: ContactSupportComponent },
      { path: 'scheduler', component: SchedulerComponent },
      { path: 'report-list', component: ReportsComponent }

    ]
  },
  {
    path: '', component: LayoutComponent, canActivate: [NoAuthGuard],
    children: [
      { path: 'public-dashboard', component: PublicDashboardComponent }
    ]
  },
  {
    path: '', component: LayoutComponent,
    children: [
      { path: 'packages', component: SubscribePackageComponent },
      { path: 'faq', component: FaqComponent }
    ]
  },
  { path: 'sandbox', component: SandBoxDashboardComponent},
  { path: 'sandbox-interceptor', component: SandBoxInterceptorComponent},
  // {path: "access-customer", component: ""},
  { path: '**', redirectTo: 'public-dashboard' }
];


//Meta data of modules
@NgModule({
  declarations: [
    ...components,
    ...directives,
    ...dialogs,
    ...pipes,
    RolesComponent,
    PlayListComponent
  ],
  entryComponents: [
    ...dialogs
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes, { enableTracing: false }),
    BrowserAnimationsModule,
    ...MaterialModules,
    FlexLayoutModule,
    GraphModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCSHxrflIRZl9HAoTeyzUl47J61hA4B1sE', libraries: ['places']
    }),
    translateModule,
    Ng4GeoautocompleteModule.forRoot(),
    ColorPickerModule,
    OpenTokModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    CKEditorModule,
    DndModule.forRoot(),
    ResizableModule,
    NgxMatSelectSearchModule
  ],
  providers: [...services, ...guards, ...pipes, httpInterceptor],
  bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/app.module.ts